<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="100px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="优惠券名称">
                <el-input v-model="queryForm.couponName"></el-input>
            </el-form-item>
            <el-form-item label="所属用户">
                <el-input v-model="queryForm.userName"></el-input>
            </el-form-item>
            <el-form-item label="所属产品">
                <el-input v-model="queryForm.productName"></el-input>
            </el-form-item>
            <el-form-item label="优惠券类型">
                <el-select v-model="queryForm.couponType" placeholder="请选择优惠券类型" clearable style="width: 175px">
                    <el-option v-for="item in couponTypeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopUserCouponList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group"></div>
                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshShopUserCouponList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table :data="shopUserCouponList" row-key="id" height='100%' @selection-change="handleSelectionChange" size="small">
                <el-table-column align="center" type="selection" width="60px"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="mppUser.userName" label="所属用户" width="150px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="couponName" label="优惠券名称" width="150px">
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="couponType" label="优惠券类型" width="150px">
                    <template slot-scope="scop">
                        <div>{{ computeCouponType(scop.row.couponType) }}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="couponType" label="优惠券品类" width="150px">
                    <template slot-scope="scop">
                        <div>{{ computeCouponTarget(scop.row.couponTarget) }}</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="shopProduct.productName" label="所属产品" width="150px">
                    <template slot-scope="scop">
                        <div v-if="scop.row.shopProduct">
                            {{ scop.row.shopProduct.productName }}
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="isUse" label="是否使用" width="100px">
                    <template slot-scope="scop">
                        {{ scop.row.isUse == 0 ? '未使用' : '已使用' }}
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="useTime" label="使用时间" width="180px">
                    <template slot-scope="scop">
                        <div v-if='scop.row.useTime'>{{ $moment(scop.row.useTime).format('YYYY-MM-DD HH:mm:ss') }}</div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="couponMoney" label="优惠券金额" width="150px">
                </el-table-column>
<!--                <el-table-column :show-overflow-tooltip="true" align="center" prop="grantTime" label="优惠券时间" width="180px">-->
<!--                    <template slot-scope="scop">-->
<!--                        {{ $moment(scop.row.grantTime).format('YYYY-MM-DD HH:mm:ss') }}-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column :show-overflow-tooltip="true" align="center" prop="useExpire" label="使用截止时间" width="180px">
                    <template slot-scope="scop">
                        {{ $moment(scop.row.useExpire).format('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="useTime" label="优惠券过期时间" width="180px">
                    <template slot-scope="scop">
                        {{ $moment(scop.row.useExpire).format('YYYY-MM-DD HH:mm:ss') }}
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="useRequire" label="满足金额" width="150">
                    <template slot-scope="scop">
                        <div v-if='scop.row.useRequire'>{{scop.row.useRequire}}</div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>

                <!-- <el-table-column
          fixed="right"
          align="center"
          label="操作"
          width="250"
        >
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkShopUserCoupon(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
            </div>
          </template>
        </el-table-column> -->
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { get, deleteFun } from '@/utils/request.js';

export default {
    props:{
        couponId:{
            type: String,
            default: ''
        }
    },
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopUserCouponList();
                this.getShopUserCouponList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopUserCouponList();
                this.getShopUserCouponList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                couponName: '', //优惠券名称
                userName: '', //优惠券所属用户
                productName: '', //所属产品
                couponType: '' //优惠券类型
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopUserCouponState: 'add',
            shopUserCouponStates: {
                add: '新建用户优惠券',
                check: '查看用户优惠券',
                edit: '修改用户优惠券'
            },

            multipleSelection: [],
            shopUserCouponList: [],
            shopUserCoupon: {
                id: '', //id
                couponName: '', //优惠券名称
                couponMoney: '', //优惠券金额
                useExpire: '', //优惠券使用过期时间
                grantTime: '', //优惠券发放时间
                isUse: '', //是否已使用:0为未使用；1为已使用
                isExpire: '', //是否失效 ：0为未失效 ；1 已失效
                receiveTime: '', //优惠券领取时间
                userId: '', //优惠券所属用户id
                couponPhoto: '', //优惠券图片
                receiveCouponId: '', //领取的优惠券id
                productId: '', //所属产品id
                couponDemand: '', //所需满减金额
                couponType: '', //1 满减 2 无门槛
                createUserId: '', //创建者
                createTime: '', //创建时间
                updateUserId: '', //更新者
                updateTime: '', //更新时间
                deleteFlag: '' //是否删除 0 正常 1 删除
            },
            btnLoading: false,

            rules: {},
            //优惠券类型
            couponTypeList: [],//优惠券的类型枚举
            couponTargetList: [],//优惠券品类枚举
            srcList:[''],//大图预览
        };
    },
    created() {
        this.couponTypeEnum();
        this.couponTargetEnum();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopUserCouponList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopUserCouponList = [];
        },
        resetDialog() {
            this.shopUserCouponState = 'add';
            this.showDialog = false;
            this.queryForm = {
                couponName: '', //优惠券名称
                userName: '', //优惠券所属用户
                productName: '', //所属产品
                couponType: '' //优惠券类型
            };
            this.getShopUserCouponList();
        },

        checkShopUserCoupon(shopUserCouponId) {
            console.log(shopUserCouponId);
            this.currentShopUserCouponId = shopUserCouponId;

            this.getShopUserCouponById();
            this.showDialog = true;
            this.shopUserCouponState = 'check';
        },
        refreshShopUserCouponList() {
            this.resetShopUserCouponList();
            this.getShopUserCouponList();
        },
        getShopUserCouponList() {
            this.loading = true;
            get(`/shop/couponreceive/findList`, { ...this.queryForm, couponId:this.couponId, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopUserCouponList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getShopUserCouponById() {
            get(`/shop/couponreceive/get`, { id: this.currentShopUserCouponId }).then((res) => {
                if (res.success) {
                    this.shopUserCoupon = { ...this.shopUserCoupon, ...res.shopUserCoupon };
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopUserCouponList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopUserCouponList();
        },
        updateSrcList(src){
            this.srcList[0] = src
        },

        // 获取优惠券类型枚举
        couponTypeEnum(){
            get("/mpp/utils/getEnum",{ enumType:"coupon_type" }).then((res)=>{
                if(res.success){
                    this.couponTypeList = res.enumList
                }
            })
        },

        // 获取优惠券分类枚举
        couponTargetEnum(){
            get("/mpp/utils/getEnum",{ enumType:"coupon_target" }).then((res)=>{
                if(res.success){
                    this.couponTargetList = res.enumList
                }
            })
        },

        // 优惠券类型计算
        computeCouponType(type){
            for (let i = 0; i < this.couponTypeList.length; i++) {
                if(this.couponTypeList[i].key == type){
                    return this.couponTypeList[i].value
                }
            }
        },

        // 优惠券品类计算
        computeCouponTarget(target){
            for (let i = 0; i < this.couponTargetList.length; i++) {
                if(this.couponTargetList[i].key == target){
                    return this.couponTargetList[i].value
                }
            }
        },
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.user-coupon-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
</style>
